import React from "react";

/**
 * Opsora wordmark — locked typography.
 * Unified DM Sans across the whole app; brand recognition comes from
 * the slate "Ops" + copper "ora" colour split (weight 600).
 */
const SIZES = {
  sm: { fontSize: "16px" },
  md: { fontSize: "20px" },
  lg: { fontSize: "28px" },
  xl: { fontSize: "36px" },
};

export default function OpsoraWordmark({ size = "md", className = "" }) {
  const { fontSize } = SIZES[size] || SIZES.md;
  const shared = {
    fontFamily: "var(--font-display)",
    fontWeight: 600,
    fontStyle: "normal",
    fontSize,
    letterSpacing: "-0.01em",
    lineHeight: 1,
  };
  return (
    <span
      className={`wordmark-text ${className}`}
      style={{ display: "inline-flex", alignItems: "baseline" }}
      data-testid="opsora-wordmark"
    >
      <span style={{ ...shared, color: "var(--slate-900)" }}>Ops</span>
      <span style={{ ...shared, color: "var(--accent)" }}>ora</span>
    </span>
  );
}
